import { useEffect, useState } from "react";
import { getRelatedCxItem } from "../../../../../../Api";
import { useAuth0 } from "@auth0/auth0-react";
import { Box, Flex, Modal, Text } from "@mantine/core";
import CallTextArea from "../Gong-call/CallTextArea";
import { stripHtml } from "../../../../../../utils";
import SurveyTitle from "./SurveyTitle";
import { getOriginalItemViewLabel } from "../../../../../../utils/evidence/businessCategoryOriginalLabels";
import { resolveEvidenceDisplayOrigin } from "../../../../../../utils/evidence/evidenceDisplayOrigin";


const Survey = ({item}:{item: any}) => {
  const auth0 = useAuth0()
  const [surveyItem, setSurveyItem] = useState<any>({})
  const [opened, setOpened] = useState(false);

  const excerptsArr: any [] =  item?.excerpts || [];

  const highlightExcerpts = (html: string, excerpts: any[]) => {
    if (!html || !excerpts.length) return html;
    
    let processedHtml = html;
    
    // Sort excerpts by start position in reverse order to avoid position shifting
    const sortedExcerpts = [...excerpts].sort((a, b) => b.excerptFirstChar - a.excerptFirstChar);
    
    sortedExcerpts.forEach(excerpt => {
      const start = excerpt.excerptFirstChar;
      const end = excerpt.excerptLastChar + 1; // Add 1 to highlight one more character
      const text = processedHtml.substring(start, end);
      const highlightedText = `<span style="background-color: #FFF9A0;">${text}</span>`;
      processedHtml = processedHtml.substring(0, start) + highlightedText + processedHtml.substring(end);
    });
    
    // Remove <br><br> before the first Answer and add line breaks before subsequent Answers
    processedHtml = processedHtml.replace(/<br><br>\s*Answer:/, 'Answer:');
    processedHtml = processedHtml.replace(/Answer:/g, '<br/><strong>Answer:</strong>');
    processedHtml = processedHtml.replace(/Question:/g, '<br/><br/><strong>Question:</strong>');
    processedHtml = processedHtml.replace(/<br>/g, '');
    
    return processedHtml;
  };

  const loadGongCall = (cxItemIdForGong: string) => {
    getRelatedCxItem(cxItemIdForGong, auth0)
      .then((res) => {
        setSurveyItem(res)
      })
      .catch((e) => console.log(e));
  };

  const title = surveyItem?.surveyName
  const submitter = surveyItem?.sureySubmitter
  const ml_text = surveyItem?.ml_text
  const processedEngagementDetails = highlightExcerpts(ml_text, excerptsArr);



  useEffect(() => {
    if (item?.cxItemId) {
      loadGongCall(item?.cxItemId);
    }
  }, [item]);

  return (
    <Box mt={15}>
      {opened && <Modal
        opened={opened}
        centered
        onClose={() => setOpened(false)}
        size="750px"
        padding={0}
        styles={{
          close: {
            marginRight: "40px",
            marginTop: "16px",
            
          },
        }}
        title={<SurveyTitle cxItem={surveyItem} origin={resolveEvidenceDisplayOrigin({ cxItem: surveyItem }) || surveyItem?.origin || 'N/A'}/>} 
      >
        <Flex pl={36} pt={16}>
          <Text fz={14} mr={4}>Submitter:</Text>
          <Text fz={14} >{submitter || 'N/A'}</Text>
        </Flex>
        <Box pl={36} h={600} pb={8} style={{ height: '100%',  overflow: 'hidden',
          position: 'relative' }}>
          <iframe
            srcDoc={`<html><head><style>
                body {
                  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
                  font-size: 14px;
                  line-height: 1.69;
                  margin: 0;
                  min-height: 95%;
                  padding-right: 46px;
                }
                html {
                  height: 95%;
                }
                
                h3 {
                  
                  color: #5A5A5A;
                }
              </style></head><body>${processedEngagementDetails}</body></html>`}
            style={{ 
              width: '100%', 
              border: 'none', 
              height: '100%',
              minHeight: '470px' // 542px - 36px padding - 36px padding
            }}
            title="Engagement Content"
          />
        </Box>
       
      </Modal>}
      <CallTextArea
        title={title || ''}
        text={stripHtml(processedEngagementDetails)}
        mlData={item?.ml}
        excerptsArr={excerptsArr}
        setOpened={setOpened}
        type='survey'
        originalItemLinkLabel={
          getOriginalItemViewLabel(item?.cxItem?.businessCategory) ||
          getOriginalItemViewLabel('survey')
        }
      /> 
    </Box>
  )
}

export default Survey